import { Spinner } from '@nextui-org/spinner'

import { FC } from 'react'

// interface
interface ILoading {
  isShow: boolean
}

// component
const LoadingComponent: FC<Readonly<ILoading>> = ({ isShow }) => {
  // return
  return (
    isShow && (
      <div
        className={
          'absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-black bg-opacity-10'
        }
      >
        <Spinner color={'success'} size={'md'} />
      </div>
    )
  )
}

export default LoadingComponent
